import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Layout from '@/components/Layouts/Layout'

Vue.use(Router)

export default new Router({
  mode:'history',
  // base: 'solution',
  routes: [
    {
      path:'/',
      component:() => import('@/components/Landing')
    },
    {
      path:'/rfid',
      component:() => import('@/components/ComingSoon')
    },
    {
      path:'/mining',
      component: Layout,
      children:[{
        path:'',
        component:() => import('@/components/Mining/Home')
      }]
    },
    {
      path:'/network/product/:brand',
      component: Layout,
      children:[{
        path:'',
        component: () => import('@/components/Home'),
      }]
    },
    {
      path:'/network/product/:brand/:cat',
      component: Layout,
      children:[{
        path:'',
        component: () => import('@/components/Home'),
      }]
    },
    {
      path: '/network',
      component: Layout,
      children:[
        {
          path:'/',
          name: 'home',
          component: () => import('@/components/Home'),
        },
        {
          path: '/test',
          component: () => import('@/TestPage')
        },
        {
          path:'productdetail',
          component: () => import('@/components/ProductDetail'),
        },
        {
          path:'login',
          component: () => import('@/components/Login'),
        },
        {
          path:'register',
          component: () => import('@/components/Register'),
        },
        {
          path:'forgotpwd',
          component: () => import('@/components/ForgotPassword')
        },
        {
          path:'user',
          component: () => import('@/components/Mobile/User'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'newPhone',
          component: () => import('@/components/Mobile/NewPhone'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'changePwd',
          component: () => import('@/components/Mobile/ChangePassword'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'manageAddress',
          component: () => import('@/components/Mobile/ManageAddress'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'shoppingCart',
          component: () => import('@/components/Mobile/ShoppingCart'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'confirmPayment',
          component: () => import('@/components/Mobile/ConfirmPayment'),
          meta: {
            loginRequired: true
          }
        },
        {
          path:'contactUs',
          component: () => import('@/components/Contact'),
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js